import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const RoleBasedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    const roleMap = {
      super_admin: '/super-admin',
      admin: '/admin',
      operations: '/operations',
      property_owner: '/owner',
      client: '/client',
      housekeeping: '/housekeeping',
    };
    return <Navigate to={roleMap[user.role] || '/login'} replace />;
  }

  return children;
};

export default RoleBasedRoute;

